module.exports = "<app-main-nav *ngIf=\"this.authService.getToken()\"></app-main-nav>\n\n<router-outlet *ngIf=\"!this.authService.getToken()\"></router-outlet>"